import './PrivacyPage.css'

function PrivacyPage() {
  return (
    <div className="privacy-page">
      <section className="legal-hero">
        <div className="container">
          <h1>Personvernerklæring</h1>
          <p>Sist oppdatert: Oktober 2026</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <h2>1. Innledning</h2>
            <p>
              CommunityNord («vi», «oss» eller «vår») er forpliktet til å beskytte ditt personvern. 
              Denne personvernerklæringen forklarer hvordan vi samler inn, bruker, lagrer og beskytter 
              dine personopplysninger når du bruker våre tjenester.
            </p>

            <h2>2. Hvilke opplysninger vi samler inn</h2>
            <p>Vi samler inn følgende typer personopplysninger:</p>
            <ul>
              <li><strong>Kontaktinformasjon:</strong> Navn, e-postadresse, telefonnummer, adresse</li>
              <li><strong>Kontoinformasjon:</strong> Brukernavn, passord (kryptert), innstillinger</li>
              <li><strong>Betalingsinformasjon:</strong> Transaksjonsdata (ikke kortinformasjon)</li>
              <li><strong>Bruksdata:</strong> Loggdata, IP-adresse, enhetsinformasjon</li>
              <li><strong>Innhold:</strong> Meldinger, dokumenter og annet innhold du laster opp</li>
            </ul>

            <h2>3. Hvordan vi bruker opplysningene</h2>
            <p>Vi bruker dine personopplysninger til å:</p>
            <ul>
              <li>Levere og forbedre våre tjenester</li>
              <li>Behandle betalinger og medlemskap</li>
              <li>Sende relevante varsler og kommunikasjon</li>
              <li>Sikre og beskytte plattformen</li>
              <li>Oppfylle juridiske forpliktelser</li>
            </ul>

            <h2>4. Dine rettigheter</h2>
            <p>Du har følgende rettigheter i forhold til dine personopplysninger:</p>
            <ul>
              <li><strong>Innsyn:</strong> Be om kopi av dine opplysninger</li>
              <li><strong>Retting:</strong> Korrigere feil opplysninger</li>
              <li><strong>Sletting:</strong> Be om sletting av dine data</li>
              <li><strong>Begrensning:</strong> Begrense behandlingen</li>
              <li><strong>Portabilitet:</strong> Motta dine data i maskinlesbart format</li>
              <li><strong>Protest:</strong> Protestere mot behandling</li>
            </ul>

            <h2>5. Datalagring</h2>
            <p>
              Dataene lagres i dag på servere i Norge. Skulle det endres, lagres de i Skandinavia.
              Vi beholder dine personopplysninger så lenge 
              du har en aktiv konto, eller så lenge det er nødvendig for å levere tjenestene 
              eller oppfylle juridiske krav.
            </p>

            <h2>6. Datasikkerhet</h2>
            <p>
              Vi implementerer passende tekniske og organisatoriske tiltak for å beskytte dine 
              personopplysninger, inkludert kryptering, tilgangskontroll og regelmessige 
              sikkerhetsvurderinger.
            </p>

            <h2>7. Deling av opplysninger</h2>
            <p>
              Vi selger aldri dine personopplysninger. Vi kan dele opplysninger med:
            </p>
            <ul>
              <li>Tjenesteleverandører som hjelper oss med å drifte plattformen</li>
              <li>Betalingsbehandlere for å prosessere transaksjoner</li>
              <li>Myndigheter når loven krever det</li>
            </ul>

            <h2>8. Informasjonskapsler (Cookies)</h2>
            <p>
              Vi bruker nødvendige informasjonskapsler for at plattformen skal fungere korrekt, 
              som innlogging og språkvalg. Besøk på foreningenes nettsider telles bare hvis 
              den besøkende har sagt ja, og uten at noen id lagres. Du kan slette 
              informasjonskapsler i nettleseren din.
            </p>

            <h2>9. Endringer</h2>
            <p>
              Vi kan oppdatere denne personvernerklæringen fra tid til annen. Vi vil varsle deg 
              om vesentlige endringer via e-post eller gjennom plattformen.
            </p>

            <h2>10. Kontakt</h2>
            <p>
              For spørsmål om personvern eller for å utøve dine rettigheter, kontakt oss på:
            </p>
            <p>
              <strong>E-post:</strong> post@communitynord.com<br />
              <strong>Adresse:</strong> Norge
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default PrivacyPage
